import React from 'react';
import { DialogTitle, DialogContent, Typography, Button } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { trackMixpanelEvent } from 'utils/utilMethods';
import { MixpanelEventName } from 'utils/constants';
import Theme from 'theme';

interface SetupCompleteProps {
  onSilentLogin?: () => void;
}

function SetupComplete({ onSilentLogin }: SetupCompleteProps) {
  React.useEffect(() => {
    trackMixpanelEvent(MixpanelEventName.FREE_TRIAL_SETUP_COMPLETE_DIALOG_VIEWED);
  }, []);

  const handleClick = () => {
    trackMixpanelEvent(MixpanelEventName.FREE_TRIAL_SETUP_COMPLETE_LETS_GO_BUTTON_CLICKED);
    if (onSilentLogin) onSilentLogin();
  };

  return (
    <DialogContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 6 }}>
      <CheckCircleIcon sx={{ color: Theme.custom.colors.lightSuccessMain, fontSize: 72, mb: 2 }} />
      <DialogTitle sx={{ fontWeight: 400, fontSize: 34, textAlign: 'center', p: 0, mb: 2 }}>Setup complete</DialogTitle>
      <Typography variant='body1' sx={{ color: Theme.custom.colors.lightTextPrimary, mb: 4, textAlign: 'center' }}>
        Your next patient session just got easier.
      </Typography>
      <Button
        variant='contained'
        size='large'
        sx={{
          py: 1.5,
          px: 6,
          background: Theme.custom.colors.lightPrimaryMain,
          color: Theme.custom.colors.white,
          fontSize: 15,
          borderRadius: 8,
          boxShadow: 'none',
        }}
        onClick={handleClick}
      >
        LET&apos;S GO
      </Button>
    </DialogContent>
  );
}

export default SetupComplete;
